import React, { createContext, useContext } from 'react';

const ActivationFlowContext = createContext(false);

export const useIsActivationFlow = (): boolean =>
  useContext(ActivationFlowContext);

export const ActivationFlowProvider = ({
  children
}: {
  children: React.ReactNode;
}): JSX.Element => (
  <ActivationFlowContext.Provider value={true}>
    {children}
  </ActivationFlowContext.Provider>
);
